// *** Forgot Password Component ****
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import "../../assets/css/forgotpswd.css";
import Validation from "../../commonComponents/Validation";
import forgot from "../../assets/img/synchronize 1.svg";
import PasswordReset from "../../commonComponents/PasswordReset";

const ForgotPswd = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [loader, setLoader] = useState(false);
    const [error, setError] = useState(false);
    const [emailError, setEmailError] = useState(false);


    return (
        <div >
            <PasswordReset 
            image="forgot"
            title="Forgot Password"
            content= ""/>
        </div>
    );
};
export default ForgotPswd;
